export default __webpack_public_path__ + "static/51-7c892816423c8cea56f9d75f7471f5e3.png";